import type { TableColumn } from '@ipfabric/utils';
import { makeIsColumnSticky } from 'components/Table/helpers/makeIsColumnSticky';
import type { TableMergedState } from 'components/Table/model/TableModel';
import { selectStickyColumnsSettings } from 'components/Table/model/selectors/selectStickyColumnsSettings';
import { selectVisibleColumns } from 'components/Table/model/selectors/selectVisibleColumns';
import { array } from 'fp-ts';
import { pipe } from 'fp-ts/lib/function';
import { createSelector } from 'reselect';
import { createScopedSelector } from 'utils/react/scopedSelector';

export const selectVisibleColumnsByStickiness: (s: TableMergedState) => {
  sticky: TableColumn<any>[];
  scrolling: TableColumn<any>[];
} = createScopedSelector(() =>
  createSelector(
    selectVisibleColumns,
    selectStickyColumnsSettings,
    (visibleColumns, stickyColumnsSettings) =>
      pipe(
        visibleColumns,
        array.partition(makeIsColumnSticky(stickyColumnsSettings)),
        ({ left, right }) => ({ sticky: right, scrolling: left }),
      ),
  ),
);
